<template>
    <div id="foamtreehtml"  ref="foamtree_render" class="example" justify="center" style="height: 380px;"></div>
</template>

<script>

import {FoamTree} from "@carrotsearch/foamtree";
// highchartsMore(FoamTree);

  // import axios from "axios";
	export default {
    name: 'FoamTreeComponent',
		data() {
			return {
        foamTreeDiv: null, // Inisialisasi foamTreeDiv
        foamTreeInstance:"",
        
        dataObject: {
          groups: [],
        },
			}
		},
		mounted() {
      this.foamTreeDiv = document.getElementById('foamtreehtml');
    },
    methods: {
      resetZoom() {
      // Logika untuk mereset tampilan zoom
        console.log("Zoom has been reset!");
        // Implementasi reset zoom di sini, seperti mengatur tampilan kembali ke ukuran awal
        // Misalnya:
        this.foamTreeInstance.reset(); // Contoh panggilan ke instance foam tree
      },
      carrot(data_carot) {
         console.log('carooot')

  // Cek apakah data kosong atau tidak valid
  if (!data_carot || !data_carot.groups || data_carot.groups.length === 0) {
    const foamTreeDiv = document.getElementById('foamtreehtml');
    foamTreeDiv.removeAttribute("data-foamtree");
    foamTreeDiv.innerHTML = ''; // Kosongkan isi div jika perlu
    console.warn('Data FoamTree kosong atau tidak valid.');
    return; // Keluar dari fungsi
  }

    console.warn('aaaad.');


        const limitedData = this.limitDeepGroups(data_carot, 500); 
        const foamTreeDiv = document.getElementById('foamtreehtml');
        foamTreeDiv.removeAttribute("data-foamtree");
        this.foamTreeInstance = new FoamTree({
          id: "foamtreehtml",
        relaxationVisible: true, // Pastikan semua level divisualisasikan
          dataObject: limitedData, // Data untuk FoamTree
          onGroupClick: (event) => {
            let node = event.group; // Get the clicked node
            // Traverse up the hierarchy to find the URL (if needed)
            while (node && !node.url) {
              node = node.parent; // Move up the hierarchy

            }
            // Check if the URL is available and open it
            if (node && node.url) {
              this.handleGroupClick(event);
              // setTimeout(() => {
              //     window.open(node.url, '_blank'); // Open a new window with the URL
              // }, 1500); // Adjust timeout duration as needed
            } else {
              console.log('No URL property found on the clicked node.');
            }
          }
        });

      },
      limitDeepGroups(data, limit = 10) {
        if (!data.groups) return data;

        data.groups.forEach(level1 => {
          if (level1.groups) {
            level1.groups.forEach(level2 => {
              if (level2.groups && level2.groups.length > limit) {
                level2.groups = level2.groups.slice(0, limit);
              }
            });
          }
        });

        return data;
      },
      handleGroupClick(event) {
        let node = event.group; // Get the clicked node
        console.log(event)
        console.log(event.x)
        // Traverse up the hierarchy to find the URL
        while (node && !node.url) {
          node = node.parent; // Move up the hierarchy
        }
        // Check if the URL is available
        if (node && node.url) {
          // Optionally log node information for debugging
          if (node.label) {
            console.log('Clicked node:');
          }
          // Ensure FoamTree instance is available
          if (this.foamTreeInstance) {
              setTimeout(() => {
                  window.open(node.url, '_blank'); // Open a new window with the URL
              }, 1500); // Adjust timeout duration as needed
          } else {
            console.log('FoamTree instance not found.');
          }
        } else {
          console.log('No URL property found on the clicked node.');
        }
      },










    },
	};
</script>